import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { fromEvent, merge, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-offline-message',
  templateUrl: './offline-message.component.html',
  styleUrls: ['./offline-message.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OfflineMessageComponent implements OnInit {
  // Disabled when we're in the SDKOffline environment
  enabled = !environment.native;
  offline = false;
  seen = false;

  private ngUnsubscribe = new Subject();

  constructor(private changeRef: ChangeDetectorRef) {}

  ngOnInit(): void {
    this.offline = !window.navigator.onLine;

    const windowOnline$ = fromEvent(window, 'online');
    const windowOffline$ = fromEvent(window, 'offline');

    merge(windowOnline$, windowOffline$)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(() => {
        this.offline = !window.navigator.onLine;

        if (this.offline) {
          this.seen = false;
        }

        this.changeRef.markForCheck();
      });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  handleHeaderDismissClick() {
    this.seen = true;
  }
}
